import type { NmfcArticleResponse } from './types'

type ParseResult = {
  nmfc: string | null
  sub: string | null
}
const validFormatRegex = /^\d+(-\d+)?$/

export const parseNmfc = (code: string | null): ParseResult => {
  // Return null values if code is null or doesn't match the required format
  // Check if the code matches the required format: digits only with optional dash and sub-digits
  // Format should be either '12345' or '12345-04' (digits only)
  if (!code || !validFormatRegex.test(code)) {
    return {
      nmfc: null,
      sub: null,
    }
  }
  const match = code.split('-')

  return {
    nmfc: match[0] ?? null,
    sub: match[1] ?? null,
  }
}
export const formatSubNumber = (subNumber: number) =>
  subNumber.toString().padStart(2, '0')

export const isUnshippable = (data: NmfcArticleResponse) =>
  !data.subItems.length && !data.freightClass
